/**
 * Created by Abner Sui on 04/16/2019.
 * Description:
 *
 * ------ maintenance history ------
 * 11/12/2019 Ella Ma fixed bug if formula column a depend formula column b, b shuold not depend a
 */

import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { TileColumn, TileColumnDataType, TileColumnSetting, TileColumnConfig } from '../../../../tamalelibs/models/tile-column.model';
import { BriefObject } from '../../../../tamalelibs/models/brief-object';
import { FormulaBuilderEventType } from '../../../../widgets/formula-builder/formula-builder.model';
import { FormulaBuilderService } from '../../../../widgets/formula-builder/formula-builder.service';
import { TileModel } from '../../../../tamalelibs/models/tile.model';
import { Subscription } from 'rxjs';
import { BriefConfig } from '../../../../widgets/widgets.model';

@Component({
    selector: 'tile-formula-column-detail',
    templateUrl: './tile-formula-column-detail.component.html',
    styleUrls: ['./tile-column-detail.component.scss']
})
export class TileFormulaColumnDetailComponent implements OnInit, OnDestroy {

    @Input() config: TileColumn;
    @Input() wholeConfig: TileModel;
    @Input() briefConfig: BriefConfig;

    dataTypeList: Array<BriefObject> = [
        { id: 'text', value: 'Text' },
        { id: 'date', value: 'Date' },
        { id: 'number', value: 'Number' },
        { id: 'currency', value: 'Currency' },
        { id: 'percent', value: 'Percent' },
        { id: 'ratio', value: 'Ratio' },
    ];
    selectedDataType: BriefObject;
    displayList: Array<BriefObject> = [
        { id: '0', value: 'Date and Time' },
        { id: '1', value: 'Date Only' },
        { id: '2', value: 'Month and Year' },
        { id: '3', value: 'Year Only' }
    ];
    selectedDisplay: BriefObject;
    scaleList: Array<BriefObject> = [
        { id: '1', value: 'None' },
        { id: '2', value: 'Thousands' },
        { id: '3', value: 'Millions' },
        { id: '4', value: 'Billions' },
        { id: '5', value: 'Trillions' }
    ];
    selectedScale: BriefObject;
    decimalPlacesList: Array<BriefObject> = [
        { id: '0', value: '0' },
        { id: '1', value: '1' },
        { id: '2', value: '2' },
        { id: '3', value: '3' },
        { id: '4', value: '4' },
        { id: '5', value: '5' },
        { id: '6', value: '6' },
        { id: '7', value: '7' },
        { id: '8', value: '8' },
        { id: '9', value: '9' }
    ];
    selectedDecimalPlaces: BriefObject;
    isPercent = false;
    isRatio = false;
    multiplyBy100 = null;
    isNumber = false;

    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _formulaBuilderService: FormulaBuilderService,
    ) { }

    ngOnInit(): void {
        this.selectedDataType = this.dataTypeList.find(item => item.id === this.config.dataType);
        this._afterDataTypeChange();
    }

    ngOnDestroy(): void {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    buildFormulaClick(sourceId: string, formula: string, formulaForData: string) {
        this._destroySubscriptions.push(
            this._formulaBuilderService.open({
                fields: this.wholeConfig.columns.filter(item => item.guid !== this.config.guid),
                sourceId: sourceId,
                formula: formula,
                formulaForData: formulaForData,
                validLoop: true,
            }).subscribe((data) => {
                this._handleForFormulaBuilder(data);
            })
        );
    }

    onDataTypeChange(value) {
        this.selectedDataType = value;
        this.config.dataType = this.selectedDataType.id;
        this._afterDataTypeChange();
        this.briefConfig.feedbackSubject$.next(this.isNumber);
    }

    onDecimalPlacesChange(value) {
        this.selectedDecimalPlaces = value;
        this.config.settings.decimalPlaces = this.selectedDecimalPlaces.id;
    }

    onDisplayChange(value) {
        this.selectedDisplay = value;
        this.config.settings = new TileColumnSetting();
        this.config.settings.display = this.selectedDisplay.id;
    }

    onMultipleMDLChange(value) {
        if (!this.config.config) {
            this.config.config = new TileColumnConfig();
        }
        this.config.config.isMultipleMDL = value;
    }

    onMultiplyBy100Change(value) {
        this.multiplyBy100 = value;
        this.config.settings.multiplyBy100 = this.multiplyBy100;
    }

    onScaleChange(value) {
        this.selectedScale = value;
        this.config.settings.scale = this.selectedScale.id;
    }

    private _afterDataTypeChange() {
        if (this.selectedDataType.id === 'text') {
            this.isPercent = false;
            this.isRatio = false;
            this.selectedDecimalPlaces = null;
            this.selectedScale = null;
            this.multiplyBy100 = null;
            this.isNumber = false;
            if (this.config.settings) {
                this.config.settings = new TileColumnSetting();
            }
        } else if (this.selectedDataType.id === 'date') {
            this.isPercent = false;
            this.isRatio = false;
            this.selectedDecimalPlaces = null;
            this.selectedScale = null;
            this.multiplyBy100 = null;
            this.isNumber = false;
            if (this.config.settings && this.config.settings.display) {
                this.selectedDisplay = this.displayList.find(item => item.id === this.config.settings.display);
            } else {
                this.selectedDisplay = this.displayList[1];
                this.config.settings = new TileColumnSetting();
                this.config.settings.display = this.selectedDisplay.id;
            }
        } else {
            this.isNumber = true;
            if (!this.config.settings) {
                this.config.settings = new TileColumnSetting();
            }
            if (!this.config.settings.negatives) {
                this.config.settings.negatives = 1;
            }
            if (this.config.settings.decimalPlaces) {
                this.selectedDecimalPlaces = this.decimalPlacesList.find(item => item.id === this.config.settings.decimalPlaces);
            } else {
                this.selectedDecimalPlaces = this.decimalPlacesList[2];
                this.config.settings.decimalPlaces = this.selectedDecimalPlaces.id;
            }
            if (this.selectedDataType.id === TileColumnDataType.PERCENT) {
                if (this.config.settings.multiplyBy100 !== null && this.config.settings.multiplyBy100 !== undefined) {
                    this.multiplyBy100 = this.config.settings.multiplyBy100;
                } else {
                    this.multiplyBy100 = true;
                    this.config.settings.multiplyBy100 = this.multiplyBy100;
                }
                this.isPercent = true;

                this.isRatio = false;
                this._clearScale();
            } else if (this.selectedDataType.id === TileColumnDataType.RATIO) {
                this.isRatio = true;

                this.isPercent = false;
                this._clearScale();
                this._clearMultiplyBy100();
            } else {
                if (this.config.settings.scale) {
                    this.selectedScale = this.scaleList.find(item => item.id === this.config.settings.scale);
                } else {
                    this.selectedScale = this.scaleList[0];
                    this.config.settings.scale = this.selectedScale.id;
                }

                this.isPercent = false;
                this.isRatio = false;
                this._clearMultiplyBy100();
            }
        }
    }

    private _clearMultiplyBy100() {
        this.multiplyBy100 = null;
        if (this.config.settings && this.config.settings.multiplyBy100 !== null && this.config.settings.multiplyBy100 !== undefined) {
            delete this.config.settings.multiplyBy100;
        }
    }

    private _clearScale() {
        this.selectedScale = null;
        if (this.config.settings && this.config.settings.scale) {
            delete this.config.settings.scale;
        }
    }

    private _handleForFormulaBuilder(event) {
        if (event.type === FormulaBuilderEventType.saveFormula) {
            const oldFormula = this.config.formula;
            const oldFormulaForData = this.config.formulaForData;
            this.config.formula = event.payload.formula;
            this.config.formulaForData = event.payload.formulaForData;
            const isLoop = this._isLoopDependence({
                guid: event.payload.sourceId,
                formulaForData: event.payload.formulaForData
            });
            if (isLoop) {
                this.config.formula = oldFormula;
                this.config.formulaForData = oldFormulaForData;
                this._formulaBuilderService.showError();
                return;
            } else {
                this._formulaBuilderService.close();
            }
        }
    }

    private _isLoopDependence(data, columnGuids = []) {
        let isLoop;
        const dependColumns = this.wholeConfig.columns.filter(item => data.formulaForData.indexOf(item.guid) !== -1 &&
            item.columnType === 'Formula');
        if (dependColumns && dependColumns.length > 0) {
            if (columnGuids.indexOf(data.guid) !== -1) {
                isLoop = true;
            } else {
                columnGuids.push(data.guid);
                for (const column of dependColumns) {
                    isLoop = this._isLoopDependence({
                        guid: column.guid,
                        formulaForData: column.formulaForData
                    }, columnGuids);
                    if (isLoop) {
                        break;
                    } else {
                        columnGuids = [columnGuids[0]];
                    }
                }
            }
        } else {
            isLoop = false;
        }
        return isLoop;
    }

}
